module.exports = "<%- visualization.code -%>\n"